import React from 'react'

const HtmlMastery = () => {
  return (
    <div>HtmlMastery</div>
  )
}

export default HtmlMastery